var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 112.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,24.6L21.6,40.5v8.1H25v-5.8h12.9V28h27.2v20.7h3.4V24.6H35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,73.5h40.1v11H25V73.5z M57.4,55.7v11h6.7v2.5h-9.5V55.7H57.4z M39.6,55.7h4.1l2.4,9.9l2.4-9.9h4.1v13.5H50 V60l-2.5,9.2h-2.8L42.2,60v9.2h-2.6C39.6,69.2,39.6,55.7,39.6,55.7z M26.2,55.7h3.3l2.4,4.4l2.5-4.4h3.3l-4.1,6.5l4.4,7h-3.4 L32,64.6l-2.7,4.6H26l4.4-6.9L26.2,55.7z M17.7,51.3v22.2h3.9v14.4h46.9V73.5h3.9V51.3H17.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.04a38c3b68bf126ebd3f6d0404afde42.svg";
export { ForwardRef as ReactComponent };